import Swiper from "@modules/swiper";
import { Navigation, Pagination, A11y, Keyboard } from "@modules/swiper/modules";

// import '@modules/swiper/css';
// import "@modules/swiper/css/a11y";
// import "@modules/swiper/css/keyboard";
// import "@modules/swiper/css/navigation";
// import "@modules/swiper/css/pagination";
import $ from "@modules/jquery";
var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";

export default () => {
    const swiperSliderElement = document.querySelector(".slider-preview");
    if (swiperSliderElement) {
        // Crea l'istanza del Swiper
        const swipersliderPreview = new Swiper(swiperSliderElement, {
            modules: [Navigation, Pagination, A11y, Keyboard],
            a11y: {
                prevSlideMessage: SlideMessagePrev,
                nextSlideMessage: SlideMessageNext,
            },
            slidesPerView: 1.2,
            slideToClickedSlide: true,
            // loop: true,
            spaceBetween: 20,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            grabCursor: true,
            navigation: {
                prevEl: ".arrow-left-sliderProduct",
                nextEl: ".arrow-right-sliderProduct",
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 30,
                },
            },
            //on: {
            //    init: function () {
            //        toggleDidascalia(this); // Eseguito al momento dell'inizializzazione


            //    },
            //    slideChange: function () {
            //        toggleDidascalia(this); // Eseguito al cambio di slide


            //    },
            /*},*/
        });

        //// Gestione aria-hidden e tabindex
        //swiper.on("slideChange", function () {
        //    const slides = document.querySelectorAll(".swiper-slide");
        //    slides.forEach((slide, index) => {
        //        slide.setAttribute("aria-hidden", index !== swiper.activeIndex); // Mostra solo la slide attiva
        //        slide.setAttribute("tabindex", index === swiper.activeIndex ? "0" : "-1"); // Solo la slide attiva � tabulabile
        //    });
        //});
    } else {
        console.warn("Elemento .swiper non trovato.");
    }
    
};
